// Copyright 2022 - 2023 Fewcha. All rights reserved.

export type BlockchainToken = {
  creator: string;
  collection: string;
  name: string;
  description: string;
  largest_property_version: string;
  maximum: string;
  supply: string;
  uri: string;
};

export type TokensReducer = {
  tokens: BlockchainToken[];
  loading: boolean;
};

export const defaultTokensReducer: TokensReducer = {
  tokens: [],
  loading: false,
};
